import { Auth } from '@nackle/bridge';
import { ID_URL } from 'endpoints';

const auth = new Auth( {
    authority: ID_URL,
    debug: false,
} );

export default auth;

export function authRequestMiddleware( url, options = {} ) {
    if ( !auth || !auth.state || !auth.state.access_token ) {
        return;
    }

    options.headers = {
        ...( options.headers || {} ),
        'authorization': `Bearer ${ auth.state.access_token }`,
    };
}

export function authRouteMiddleware( action, nextRoute, prevRoute ) {
    // we aren't signed in yet, so continue
    if ( !auth.state.access_token ) {
        return action.ok();
    }

    const nextCompanyId = nextRoute?.state?.params?.companyId;
    // if the next companyId is the same as the last companyId, continue
    if ( nextCompanyId === auth.state.company_id ) {
        return action.ok();
    }

    // switch to the new company
    auth.delegate( nextCompanyId ).then( () => {
        action.ok();
    } ).catch( error => {
        console.error( error );
    } );
}
